const API_ENVIRONMENTS = {
  local: {
    baseUrl: "http://localhost:8040",
    apiPrefix: "api/v1",
  },
  demo: {
    baseUrl: "https://inventorydemoapi.anaxistech.com",
    apiPrefix: "api/v1",
  },
  stage: {
    baseUrl: "https://inventoryapi.anaxistech.com",
    apiPrefix: "api/v1",
  },
  live: {
    baseUrl: "https://inventoryliveapi.anaxistech.com",
    apiPrefix: "api/v1",
  },
};

const ENVIRONMENT_ALIASES = {
  local: "local",
  dev: "local",
  development: "local",
  demo: "demo",
  stage: "stage",
  staging: "stage",
  live: "live",
  prod: "live",
  production: "live",
};

function trimSlashes(value = "") {
  return value.replace(/^\/+|\/+$/g, "");
}

function trimTrailingSlash(value = "") {
  return value.replace(/\/+$/g, "");
}

function getEnvValue(name, fallback) {
  const value = process.env[name];
  return value === undefined || value.trim() === "" ? fallback : value.trim();
}

function getApiEnvironment(value = "") {
  return value.split("//")[0].split("#")[0].trim().toLowerCase();
}

function buildApiBaseUrl(baseUrl, apiPrefix) {
  const cleanBaseUrl = trimTrailingSlash(baseUrl);
  const cleanApiPrefix = trimSlashes(apiPrefix);

  if (!cleanBaseUrl) return "";
  if (!cleanApiPrefix) return cleanBaseUrl;

  return `${cleanBaseUrl}/${cleanApiPrefix}`;
}

function resolveEnvironment() {
  // If running in browser and hostname is not localhost/127.0.0.1, prioritize hostname detection
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname.toLowerCase();
    const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0";
    if (!isLocalhost) {
      if (host.includes("demo")) return "demo";
      if (host.includes("stage")) return "stage";
      if (host.includes("live") || host.includes("prod")) return "live";
    }
  }

  const envVal =
    getApiEnvironment(process.env.REACT_APP_API_ENV) ||
    getApiEnvironment(process.env.REACT_APP_ENV);

  if (envVal) {
    return ENVIRONMENT_ALIASES[envVal] || envVal;
  }

  return "local";
}

const apiEnvironment = resolveEnvironment();
const environmentDefaults =
  API_ENVIRONMENTS[apiEnvironment] || API_ENVIRONMENTS.local;

// Check for environment-specific override from process.env:
// e.g. REACT_APP_DEMO_API_BASE_URL, REACT_APP_STAGE_API_BASE_URL, REACT_APP_LIVE_API_BASE_URL, REACT_APP_LOCAL_API_BASE_URL
const envSpecificBaseUrl = getEnvValue(`REACT_APP_${apiEnvironment.toUpperCase()}_API_BASE_URL`);

const baseUrl = envSpecificBaseUrl || getEnvValue(
  "REACT_APP_API_BASE_URL",
  environmentDefaults.baseUrl,
);
const apiPrefix = getEnvValue(
  "REACT_APP_API_PREFIX",
  environmentDefaults.apiPrefix,
);

export const API_CONFIG = {
  environment: apiEnvironment,
  isDemo: apiEnvironment === "demo",
  isStage: apiEnvironment === "stage",
  isLive: apiEnvironment === "live",
  isProd: apiEnvironment === "live",
  isLocal: apiEnvironment === "local",
  baseUrl,
  apiPrefix,
  apiBaseUrl: buildApiBaseUrl(baseUrl, apiPrefix),
};
